export default "__VITE_ASSET__ea1327b5__"